var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFillHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1018 2.28592C15.702 1.87825 15.2273 1.55485 14.7048 1.33421C14.1823 1.11357 13.6222 1 13.0566 1C12.491 1 11.931 1.11357 11.4085 1.33421C10.886 1.55485 10.4112 1.87825 10.0114 2.28592L9.18161 3.1316L8.35181 2.28592C7.54416 1.46283 6.44877 1.00043 5.30659 1.00043C4.16441 1.00043 3.06901 1.46283 2.26137 2.28592C1.45373 3.10901 1 4.22536 1 5.38939C1 6.55341 1.45373 7.66976 2.26137 8.49285L3.09117 9.33853L9.18161 15.5455L15.272 9.33853L16.1018 8.49285C16.5019 8.08537 16.8192 7.60156 17.0357 7.06905C17.2522 6.53655 17.3636 5.96579 17.3636 5.38939C17.3636 4.81298 17.2522 4.24223 17.0357 3.70972C16.8192 3.17722 16.5019 2.69341 16.1018 2.28592Z",
    fill: "#2BAE66",
    stroke: "#2BAE66",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillHeart);
export default __webpack_public_path__ + "static/media/fill-heart.700d040f2c2209b6683cb6b58976737b.svg";
export { ForwardRef as ReactComponent };